export default "__VITE_ASSET__Dvf7xbZA__"